import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditCurriculum = props => {
  const { curriculumId } = props.params

  return (
    <Edit
// @ts-ignore
      title='Edit Curriculum'
      fields={fields}
      apiPath={`admin/curriculums/${curriculumId}`}
      successRedirectPath='/events/curriculums'
      buildMenuItems={menuItems}
    />
  )
}

export default EditCurriculum
